import React, { useCallback, useRef } from 'react';

import { useFormikContext } from 'formik';
import { getRichTextContent } from 'utils/richTextUtils';

import { AcAdvancedTextInput } from 'components/AcAdvancedTextInput/AcAdvancedInput';

import { defaultGeneralTheme } from '../../GeneralSettings/defaults';


const DEFAULT_MAINTENANCE_TEXT =
  "We're currently performing maintenance. Please check back soon.";

interface MaintenanceFormValues {
  maintenanceModeRichText?: {
    text: string;
    fontColor: string;
  };
}

export const MaintenanceSectionFields: React.FC = () => {
  const { values, setFieldValue } =
    useFormikContext<MaintenanceFormValues>();
  const lastPlainText = useRef<string>(
    getRichTextContent(values?.maintenanceModeRichText?.text)
  );

  const handleProgrammaticChange = useCallback(
    (value: string) => {
      const plainText = getRichTextContent(value);
      if (plainText === lastPlainText.current) return;
      lastPlainText.current = plainText;
      setFieldValue('maintenanceModeRichText.text', value);
    },
    [setFieldValue]
  );

  const handleUserContentChange = useCallback(
    (html: string) => {
      lastPlainText.current = getRichTextContent(html);
      setFieldValue('maintenanceModeRichText.text', html);
    },
    [setFieldValue]
  );

  return (
    <div>
        <AcAdvancedTextInput
          value={values?.maintenanceModeRichText?.text ?? ''}
          setValue={handleProgrammaticChange}
          onUserContentChange={handleUserContentChange}
          error={false}
          enableColorPicker={true}
          fontColor={
            values?.maintenanceModeRichText?.fontColor ??
            defaultGeneralTheme.maintenanceModeRichText?.fontColor ??
            'rgb(0, 0, 0)'
          }
          placeholder={DEFAULT_MAINTENANCE_TEXT}
        />
    </div>
  );
};
